export interface IWidgetType {
  id: string
  title: string
  thumbnail: string
  description?: string
}

export const WIDGET_TYPES: IWidgetType[] = [
  {
    id: 'overall-rating',
    title: 'Overall',
    thumbnail: 'assets/images/widgets/widget-preview-partner-anon.png',
    description:
      'Display live ratings of your overall scores for an individual development',
  },
  {
    id: 'reviews-summary',
    title: 'Reviews Summary',
    thumbnail: 'assets/images/widgets/widget-preview-single-review-anon.png',
    description:
      'Display live ratings and include selected review snippets to showcase your resident insights',
  },
  {
    id: 'start-review',
    title: 'Start A Review',
    thumbnail: 'assets/images/widgets/widget-preview-write-review-anon.png',
    description:
      'Use this widget to help capture more resident reviews and help promote your developments',
  },
  {
    id: 'company-widget',
    title: 'Company',
    thumbnail: 'assets/images/widgets/widget-preview-company-widget-anon.png',
    description:
      'Display live ratings of your overall score across your portfolio of developments',
  },
]

export const WIDGET_STEPS = [
  {
    step: 1,
    label: 'Select Widget',
  },
  {
    step: 2,
    label: 'Setup Widget',
  },
  {
    step: 3,
    label: 'Export Code',
  },
]

interface IDevOption {
  label: string
  value: number
}

export const getDevelopmentOptions = (data: any) => {
  const options: IDevOption[] = []
  if (!data || !Object.keys(data).length) {
    return options
  }

  Object.keys(data).map((item: any) => {
    options.push({
      value: data[item].id,
      label: data[item].name,
    })
  })

  return options
}
